// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"29748292","175":"ae7c6927","659":"2b5122fe","667":"c3fcf84a","918":"ea930369"}[chunkId] + ".chunk.js";
};